import { flowWithSafeComponent } from '@atlassian/jira-issue-view-common-utils/src/flow-with-safe-component/index.tsx';
import { connect } from '@atlassian/jira-issue-view-react-redux/src/index.tsx';
import Title from './title/index.tsx';
import Heading from './view.tsx';
import OldSectionHeadingIcons from './old-section-heading-icons/index.tsx';
import HeaderSectionHeadingIcons from './section-heading-icons/index.tsx';

export default flowWithSafeComponent(
	connect(
		() => ({
			Title,
			OldSectionHeadingIcons,
			HeaderSectionHeadingIcons,
		}),
		{},
	),
)(Heading);
